export default "__VITE_ASSET__DTURwdZk__"